export default "__VITE_ASSET__DQbqGdIz__"